import Service from "./service";
import Query from "../models/query";
import jqXHR = JQuery.jqXHR;

export default class QueryService extends Service {
  url: string;
  currentSearch: jqXHR;
  timer: any = null;
  timeout: number;
  data: object = {};
  options: object = {};

  constructor({endpoint = '', timeout = window.AppConfig.queryTimeout(), data = {}, options = {}}: {endpoint: string, timeout?: number, data?: object, options?: object}) {
    super();
    this.url = endpoint;
    this.currentSearch = null;
    this.timeout = timeout;
    this.data = data;
    this.options = options;
  }

  kill() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }

  fetch(query) {
    this.kill();
    return new Promise((resolve, reject) => {
      this.timer = setTimeout(() => {
        if (query instanceof Query) {
          query.inProgress = true;
        }
        if (this.currentSearch !== null) {
          this.currentSearch.abort();
          this.currentSearch = null;
        }

        // first arg as empty object to prevent mutation of this.data
        const data = window.AppConfig.mergeJson(
            {},
            this.data,
            query instanceof Query ? query.asJson() : query,
            {authenticity_token: this.csrfToken()}
        );

        data.options = window.AppConfig.mergeJson(
            this.options,
            query.options
        );

        this.currentSearch = $.ajax({
          url: this.url,
          type: 'GET',
          dataType: 'json',
          data: data
        }).done(function (result) {
          this.currentSearch = null;
          if (query instanceof Query) {
            query.inProgress = false;
          }
          resolve(result);
        }).fail(function (result) {
          // Likely aborted by this function itself
          if (!(result["statusText"] && result["statusText"] === "abort")) {
            reject(result);
          }
        });
      }, this.timeout);
    });
  }
}

